import React, { useState, useContext } from "react";
import styles from "./styles/PosCartSettlement.module.css";
import DataContext from "../../../context/DataContext";
import { formatDateToLocalDate } from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import POSDataContext from "../../../context/POSDataContext";
import ButtonExpand from "../button_expand/ButtonExpand";
import CloseButton from "../close_button/CloseButton";
import { t } from "i18next";
import { axiosSW } from "../../../api/axiosDefaults";
import useNumberFormat from "../../../hooks/useNumberFormat";

import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";

import { ReactComponent as IconTax } from "../../../assets/tax.svg";
import { ReactComponent as IconGavel } from "../../../assets/gavel.svg";
/**
 * SideTicket component
 */
const PosCartSettlement = ({
    ticket,

    currency,
    handleDelete,
}) => {
    const formatNum = useNumberFormat();

    return (
        <>
            <div className={`${styles.main_ticket_container}   flex-container`}>
                <div className={`${styles.info_container} v-flex-container`}>
                    <div className={`${styles.ticket_info} ${styles.name_tag}`}>
                        <span>
                            <IconGavel
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {ticket?.productCode}
                    </div>

                    <div
                        className={`${styles.ticket_info} ${styles.hide_info} ${styles.tax_tag}`}
                    >
                        <span>
                            <IconTax
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {`${currency}${formatNum(ticket.taxTotal || 0)}`}
                    </div>
                    <div
                        className={`${styles.ticket_info} ${styles.amount_tag} `}
                    >
                        <span>
                            <IconBill
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {`${currency}${formatNum(ticket.subTotal || 0)}`}
                    </div>
                </div>
                <div
                    className={`${styles.close_button_container} flex-container`}
                >
                    <CloseButton
                        tab={true}
                        tabBackground={true}
                        onClickFuction={() => handleDelete(ticket?.cartItemID)}
                    />
                </div>
            </div>
            <div
                className={`${styles.main_instalments_container} flex-container`}
            >
                <div
                    className={`${styles.instalments_container} v-flex-container`}
                >
                    <div
                        className={`${styles.instalments_header} flex-container`}
                    >
                        <span
                            className={`${styles.instalments_header_entry} ${styles.instalment_name_tag}`}
                        >
                            {t("instalment")}
                        </span>
                        <span
                            className={`${styles.instalments_header_entry} ${styles.hide_info} ${styles.instalment_tax_tag} ${styles.label_centre} `}
                        >
                            {t("tax")}
                        </span>
                        <span
                            className={`${styles.instalments_header_entry} ${styles.instalment_amount_tag}`}
                        >
                            {t("amount")}
                        </span>
                    </div>

                    {ticket?.installmentItems?.map((item) => (
                        <div
                            key={item?.chargeID}
                            className={`${styles.instalment_info} flex-container`}
                        >
                            <span
                                className={`${styles.instalment_info_entry} ${styles.instalment_name_tag}`}
                            >
                                {item?.text.split("#")[1]}
                            </span>

                            <span
                                className={`${styles.instalment_info_entry} ${styles.hide_info} ${styles.instalment_tax_tag}`}
                            >
                                {`${currency}${formatNum(item?.taxTotal)}`}
                            </span>
                            <span
                                className={`${styles.instalment_info_entry} ${styles.instalment_amount_tag} `}
                            >
                                {`${currency}${formatNum(item?.subTotal)}`}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default PosCartSettlement;
